import classNames from 'classnames'
import ScrollToViewByHash from 'components/ScrollToViewByHash'
import _ from 'lodash'
import React, {useMemo} from 'react'
import {BsCircleFill, BsDiamond, BsFillDiamondFill} from 'react-icons/bs'
import {Link} from 'react-router-dom'
import {headings} from 'views/SlateEditor/components/Heading'
import {findDeepNodes, toBase64} from 'views/SlateEditor/functions'
import useTranslate from '../../../modules/local/useTranslate'
import Toggle from '../../../components/Toggle'
import {renderIf} from "../../Shared";

const headerTypes = headings
const headerIcons = [BsCircleFill, BsFillDiamondFill, BsDiamond]
const headerMargin = [0, 12, 24]

const TableOfContents = ({className, editorState, renderEmptyContent}) => {
    const t = useTranslate()

    const blocks = useMemo(
        () =>
            Array.from(
                findDeepNodes(editorState, (node) =>
                    headerTypes.includes(node?.type)
                ) ?? []
            ),
        [editorState]
    )

    const result = blocks.map(({type, children}) => ({
        type,
        text: _.get(children, '[0].text'),
    }))

    const itemsToShow = 5

    const blockSize = result?.length

    const stopBy =
        blockSize < 2 * itemsToShow
            ? blockSize
            : Math.min(blocks?.length, itemsToShow)

    const reachEnd = stopBy >= blockSize

    if (_.isEmpty(result) && !renderEmptyContent) {
        return null
    }

    return renderIf(
        !_.isEmpty(result),
        <div className="px-3 py-2 flex flex-col background border-l-3 border-indigo-400  shadow-block rounded-xl">
            <div className="mb-2 pb-2 border-b border-indigo-400 font-medium text-indigo-600 leading-snug tracking-wider">
                {`${t('table of contents')}: `}
            </div>
            <div className=" rounded-b-lg">
                <div className={classNames(className, 'flex flex-col gap-2')}>
                    <ScrollToViewByHash/>
                    <Toggle>
                        {(isToggle, toggle) => (
                            <React.Fragment>
                                {result
                                    .slice(0, isToggle ? result?.length : stopBy)
                                    .map(({type, text}, index) => {
                                        const spaces = headerTypes.indexOf(type)
                                        const BulletIcon = headerIcons[spaces]
                                        const margin = headerMargin[spaces]
                                        const hash = toBase64(text)
                                        if (!!!text) return null;
                                        return (
                                            <div
                                                key={index}
                                                style={{marginLeft: margin}}
                                                className="flex items-center cursor-pointer">
                                                <Link
                                                    title={text}
                                                    replace
                                                    to={(location) => ({
                                                        ...location,
                                                        hash,
                                                    })}
                                                    key={index}
                                                    className="space-x-2 inline-block max-lines-2 no-underline">
                                                    <BulletIcon size={7} className="text-color-400"/>
                                                    <span className="text-doc-sm text-color-300 hover:text-color-000 italic">
                                                        {text}
                                                    </span>
                                                </Link>
                                            </div>
                                        )
                                    })}
                                {!reachEnd && (
                                    <React.Fragment>
                                        {!isToggle && (
                                            <span className="pl-2 text-color-500">{'...'}</span>
                                        )}
                                        <div
                                            onClick={toggle}
                                            className="text-right text-xs italic px-3 cursor-pointer text-color-500 hover:text-color-100">
                                            {t(isToggle ? 'see less' : 'see more')}
                                        </div>
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        )}
                    </Toggle>
                </div>
            </div>
        </div>
    )
}

export default TableOfContents
